import { grprService } from '@/api/grpr-service'
import { arrecadacaoService } from '@/api/arrecadacao-service'
import { ugaService } from '@/api/uga-service'
import { arrecadacaoCategoriaService } from '@/api/arrecadacaocategoria-service'

export const pesquisarCategoria = async (context, payload) => {
  try {
    const response = await arrecadacaoCategoriaService.arrecadacaocategoria()
    let categoria = response.data.lista.map((e) => ({text: e.descCategoria, value: e.cdCategoria, pedirCodigo: e.pedirCodigo}))
    context.commit('setCategoria', categoria)
  } catch(e) {
    throw e
  }
}

export const pesquisarCodArrecadacao = async (context, payload) => {
  try {
    const response = await arrecadacaoService.arrecadacao()
    let arrecadacao = response.data.map((e) => ({text: e.cdArrecadacao + ' - ' + e.descCdArrecadacao, value: e.cdArrecadacao}))
    context.commit('setCodArrecadacao', arrecadacao)
  } catch(e) {
    throw e
  }
}

export const arrecadacaoPorCodigo = async (context, payload) => {
  try {
    const response = await arrecadacaoService.comParamAtivaPorArrecadacao(payload)
    let arrecadacao = response.data.map((e) => ({text: e.cdArrecadacao + ' - ' + e.descCdArrecadacao, value: e.cdArrecadacao}))
    context.commit('setCodArrecadacao', arrecadacao)
  } catch(e) {
    throw e
  }
}

export const pesquisarInstituicao = async (context, payload) => {
  try {
    const response = await ugaService.comParamAtivaPorCategoria(payload)
    let instituicao = response.data.map((e) => ({text: e.infUga, value: e.cdUga}))
    context.commit('setInstituicao', instituicao)
  } catch(e) {
    throw e
  }
}

export const pesquisarInstituicaoPorArrecadacao = async (context, payload) => {
  try {
    const response = await ugaService.comParamAtivaPorArrecadacao(payload)
    let instituicao = response.data.map((e) => ({text: e.infUga, value: e.cdUga}))
    context.commit('setInstituicao', instituicao)
  } catch(e) {
    throw e
  }
}